import { Component, OnInit } from '@angular/core';
import { HistoricoConsultaService } from 'src/app/services/http/historico-consulta.service';
import { UnidadeService } from 'src/app/services/http/unidade.service';
import { RelatorioService } from 'src/app/services/http/relatorio.service';
import { LoginService } from 'src/app/services/login.service';
import { Cliente } from 'src/app/models/cliente';
import { debounceTime, distinctUntilChanged, map, first } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

import { UsuarioService } from 'src/app/services/http/usuario.service';

@Component({
  selector: 'app-relatorio-web-socket',
  templateUrl: './relatorio-web-socket.component.html',
  styleUrls: ['./relatorio-web-socket.component.scss']
})
export class RelatorioWebSocketComponent implements OnInit {

  pesquisaDataFim;
  pesquisaDataInicio;

  idPai: any;
  dataInicio = new Date();
  dataFim = new Date();

  listaClientes: Cliente[] = [];
  clienteSelecionado = '';
  pesquisaCliente: any;

  listaUsuarios: any = [];
  usuarioSelecionado: '';
  pesquisaUsuario: any;

  inputClienteFormat = (u) => {
    return u.nomeFantasia;
  };

  inputUsuarioFormat = (r) => {
    return r.nome;
  };

  listaTipo: any[] = [];
  tipoSelecionado = '';
  listaResultado = [];

  webSocketError = false;
  webSocketIsOpen = false;
  webSocketSuport = true;
  webSocketValidate = false;
  webSocket: any;
  tipoRelatorio: string = '';
  filtros: any = { dataInicio: true, dataFim: true, tipoCliente: false, cliente: false };
  filtroUser: any = { usuario: true };

  constructor( private usuarioService: UsuarioService, private loginService: LoginService, private activedRoute: ActivatedRoute, private historicoService: HistoricoConsultaService, private unidadeService: UnidadeService) {
    this.activedRoute.data.pipe(first()).subscribe(p => {
      this.tipoRelatorio = p.tipoRelatorio || this.tipoRelatorio;
      this.filtros = p.filtros || this.filtros;

      if (!this.idPai)
        this.loginService.getLogIn().pipe(first()).subscribe(l => {
          this.idPai = l.unidade.id;
        });

      if (this.filtros.cliente) {
        this.historicoService.getlistaClientes().then(c => this.listaClientes = c);
      }

      if (this.filtros.tipoCliente) {
        this.unidadeService.getListaTipoUnidadeCliente().then(t => this.listaTipo = t);
      }

      if (this.filtroUser.usuario) {
        this.usuarioService.listarUsuario().then(u => this.listaUsuarios = u);
      }
    });

  }

  ngOnInit() {
    this.dataInicio.setDate(1);
    let dataInicio = new Date();
    let dataFim = new Date();

    dataInicio.setTime(dataFim.getTime() - (24 * 60 * 60 * 1000));
    this.setDataInicio({
      day: dataInicio.getDate(),
      month: dataInicio.getMonth() + 1,
      year: dataInicio.getFullYear(),
    });

    this.setDataFim({
      day: dataFim.getDate(),
      month: dataFim.getMonth() + 1,
      year: dataFim.getFullYear(),
    });

    this.pesquisaCliente = (text: Observable<string>) =>
      text.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        map(term => this.listaClientes.filter(
          c => (c.nomeFantasia || '').toLowerCase().indexOf(term.toLowerCase()) > -1
        ).slice(0, 10))
      )

    this.pesquisaUsuario = (text: Observable<string>) =>
      text.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        map(term => this.listaUsuarios.filter(
          u => (u.nome || '').toLowerCase().indexOf(term.toLowerCase()) > -1
        ).slice(0, 10))
      )

    this.setWebSocket();
  }

  addFiltroCliente(cliente: any) {
    //  this.filter.cliente = cliente.item;
  }

  removeFiltroCliente() {
    //this.filter.cliente = null;
    this.clienteSelecionado = '';
  }

  addFiltroUsuario(usuario: any) {
    //  this.filter.usuario = usuario.item;
  }

  removeFiltroUsuario() {
    //this.filter.usuario = null;
    this.usuarioSelecionado = '';
  }

  setDataInicio(date) {
    date =  this.dataInicio.getTime(),
    this.pesquisaDataInicio = date;
  }

  setDataFim(date) {
    date =  this.dataFim.getTime(),
    this.pesquisaDataFim = date;
  }

  formattedDate(d): string {
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [day, month, year].join('/');
  }

  refazerValidacaoWebSoket() {
    this.webSocketValidate = false;
    this.setWebSocket();
  }

  setWebSocket(saida = null) {
    if ("WebSocket" in window) {
      this.webSocket = new WebSocket("ws://localhost:9876/gerarRelatorios");

      this.webSocket.onmessage = (evt) => {
        console.info('mensagem... ', evt);
      };

      this.webSocket.onerror = (error) => {
        console.error('Erro conexão... ', error);
        this.webSocketError = true;
        this.webSocketValidate = true;
      };

      this.webSocket.onclose = () => {
        this.webSocketIsOpen = false;
        console.info("Conexão fechada... ");
      };

      this.webSocket.onopen = () => {
        console.info('abriu o websocket');
        this.webSocketError = false;
        this.webSocketIsOpen = true;
        if (saida) {
          this.webSocket.send(btoa(JSON.stringify(saida)));
        } else {
          this.webSocketValidate = true;
        }
        this.webSocket.close();
      }

    } else {
      this.webSocketSuport = false;
    }
  }


  webSocketSend() {
    let saida = {
      dataInicio: this.formattedDate(this.dataInicio),
      dataFim: this.formattedDate(this.dataFim),
      idUnidade: this.idPai,
      tipoRelatorio: this.tipoRelatorio == 'faturamento' ? '1' : '2',
      cliente: null,
      tipo: null,
      usuario: null
    };
    this.setWebSocket(saida);
  }


  ngOnDestroy() {
    if (this.webSocket) this.webSocket.close();
  }

}
